"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var RemotePasswordValidator_1 = require("./RemotePasswordValidator");
var lib_1 = require("../lib");
var BaseItemStore_1 = require("./BaseItemStore");
var ProfileStore = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileStore, _super);
    function ProfileStore(notificationsStore) {
        var _this = _super.call(this, notificationsStore, "profile") || this;
        _this.open = function () {
            _this.isOpen = true;
            _this.getItem();
        };
        _this.close = function () {
            _this.isOpen = false;
            _this.reset();
        };
        _this.createToken = function () {
            window.__sdk__.auth.createTokenApi();
        };
        _this.onCreateTokenApiSuccess = function (tokenApi) {
            _this.newTokenApi = tokenApi;
            _this.getTokensApi();
        };
        _this.clearNewToken = function () {
            _this.newTokenApi = "";
        };
        _this.getTokensApi = function () {
            _this.isLoadingTokensApi = true;
            window.__sdk__.auth.users.getTokensApi()
                .then(function (res) { return _this.onGetTokensApiSuccess(res); });
        };
        _this.onGetTokensApiSuccess = function (res) {
            _this.isLoadingTokensApi = false;
            _this.tokensApi = res.results;
        };
        _this.deleteToken = function (tokenId) {
            window.__sdk__.auth.users.deleteTokenApi(tokenId)
                .then(function (res) { return _this.getTokensApi(); });
        };
        _this.genereateTwoFactorSecret = function (password) {
            window.__sdk__.auth.users.generateTwoFactorSecret(password)
                .then(function (res) { return _this.setDataUrl(res.dataUrl); })
                .catch(function (err) { return _this.onGenerateFailed(err); });
        };
        _this.setDataUrl = function (url) {
            _this.dataUrl = url;
        };
        _this.disableTwoFactorAuth = function (password) {
            window.__sdk__.auth.users.disableTwoFactor(password)
                .then(function (data) { return _this.setItem(data); })
                .then(function () { return _this.onSubmitSuccess(); })
                .catch(function (err) { return _this.onDisableFailed(err); });
        };
        _this.enableTwoFactoAuth = function (token) {
            window.__sdk__.auth.users.enableTwoFactor(token)
                .then(function (data) { return _this.onEnableSuccess(data); })
                .then(function () { return _this.onSubmitSuccess(); })
                .catch(function (err) { return _this.onEnableFailed(err); });
        };
        _this.updatePassword = function (currentPassword, newPassword) {
            window.__sdk__.auth.users.changePassword(currentPassword, newPassword)
                .then(function () { return _this.onSubmitSuccess(); })
                .catch(function (err) { return _this.onSubmitFailed(err); });
        };
        _this.checkPassword = function (password) {
            _this.passwordValidator.checkPassword(password);
        };
        window.__sdk__.auth.on("token:api", function (tokenApi) { return _this.onCreateTokenApiSuccess(tokenApi); });
        _this.reset();
        return _this;
    }
    ProfileStore.prototype.reset = function () {
        var _this = this;
        mobx_1.transaction(function () {
            _super.prototype.reset.call(_this);
            _this.item = tslib_1.__assign({}, _this.item, { firstName: "", lastName: "", email: "", twoFactorAuth: {
                    enableTwoFactorAuth: false
                }, phone: "" });
            _this.tokensApi = mobx_1.observable.array([], { deep: false });
            _this.isLoadingTokensApi = false;
            _this.avatarUrl = "";
            _this.dataUrl = "";
            _this.isOpen = false;
            _this.passwordValidator = new RemotePasswordValidator_1.default();
            _this.newTokenApi = "";
        });
    };
    ProfileStore.prototype.getItem = function () {
        var _this = this;
        this.isLoading = true;
        this.loadError = false;
        window.__sdk__.auth.users.getMe()
            .then(function (res) { return _this.setItem(res); })
            .catch(function (err) { return _this.onLoadFailed(err); });
    };
    ProfileStore.prototype.setItem = function (data) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.isLoading = false;
            _this.item = tslib_1.__assign({}, _this.item, data);
            _this.avatarUrl = _this.item.email ? lib_1.gravatar.getUrl(_this.item.email, 100) : "";
        });
    };
    ProfileStore.prototype.submit = function () {
        var _this = this;
        var item = this.getProfileChanges();
        window.__sdk__.auth.users.updateMe(item)
            .then(function () { return _this.onSubmitSuccess(); })
            .catch(function (err) { return _this.onSubmitFailed(err); });
    };
    ProfileStore.prototype.getProfileChanges = function () {
        return {
            firstName: this.item.firstName,
            lastName: this.item.lastName,
            phone: this.item.phone
        };
    };
    ProfileStore.prototype.onGenerateFailed = function (err) {
        this.onLoadError();
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to generate two factor auth, please try to enter the password again",
            timeout: 5000
        });
    };
    ProfileStore.prototype.onEnableFailed = function (err) {
        this.onLoadError();
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to enable two factor authentication, please try to enter the token again",
            timeout: 5000
        });
    };
    ProfileStore.prototype.onDisableFailed = function (err) {
        this.onLoadError();
        this.notificationsStore.pushErrorNotification({
            title: "Operation Error",
            text: "Failed to disable two factor authentication, please try to enter the token again",
            timeout: 5000
        });
    };
    ProfileStore.prototype.onEnableSuccess = function (data) {
        var _this = this;
        mobx_1.transaction(function () {
            _this.setDataUrl("");
            _this.setItem(data);
        });
    };
    Object.defineProperty(ProfileStore.prototype, "isCheckingPassword", {
        get: function () {
            return this.passwordValidator.isCheckingPassword;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileStore.prototype, "passwordScore", {
        get: function () {
            return this.passwordValidator.passwordScore;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "passwordValidator", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "avatarUrl", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "dataUrl", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "tokensApi", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "isLoadingTokensApi", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ProfileStore.prototype, "newTokenApi", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "open", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "close", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "getItem", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "setItem", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "submit", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onCreateTokenApiSuccess", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "clearNewToken", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "getTokensApi", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onGetTokensApiSuccess", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "deleteToken", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "getProfileChanges", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "genereateTwoFactorSecret", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onGenerateFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onEnableFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onDisableFailed", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "onEnableSuccess", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "setDataUrl", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "disableTwoFactorAuth", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "enableTwoFactoAuth", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "updatePassword", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ProfileStore.prototype, "checkPassword", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], ProfileStore.prototype, "isCheckingPassword", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], ProfileStore.prototype, "passwordScore", null);
    return ProfileStore;
}(BaseItemStore_1.default));
exports.default = ProfileStore;
